// extracted by mini-css-extract-plugin
export default {"value":"FoundationParametersSection_value__MWxMX","wrapper":"FoundationParametersSection_wrapper__0Ok3f"};